<template>
  <div id="page-user-edit">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>
    <vx-card v-if="user_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
            <div class="tab-text">
              <user-edit-tab-account class="mt-4" :data="user_data" />
            </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import UserEditTabAccount     from './OperationAddTab.vue'

// Store Module
import moduleOperationList from '@/store/operation/moduleOperationList.js'

export default {
  components: {
    UserEditTabAccount
  },
  data () {
    return {
      idquotation: null,
      user_data: null,
      user_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  methods: {
    fetch_user_data (userId) {
      if (userId)
      {
      this.$store.dispatch('operationList/fetchOperation', userId)
        .then(res => { this.user_data = res.data })
        .catch(err => {
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err) 
        })
      }
      else
      {
        this.user_data = {}
      }
    }
  },
  created () {
    // Register Module UserManagement Module
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule('operationList', moduleOperationList)
      moduleOperationList.isRegistered = true
    }
    this.fetch_user_data(this.$route.params.userId)
  }
}

</script>
